import { NavLink, Outlet } from 'react-router-dom'
import { useSubscription } from '@/hooks/useSubscription'

export interface DashboardTab {
  id: string
  label: string
  to: string
  requiredFeature?: string
}

interface DashboardTabLayoutProps {
  title: string
  subtitle?: string
  tabs: DashboardTab[]
}

export default function DashboardTabLayout({ title, subtitle, tabs }: DashboardTabLayoutProps) {
  const { hasFeature } = useSubscription()

  const visibleTabs = tabs.filter(
    (tab) => !tab.requiredFeature || hasFeature(tab.requiredFeature),
  )

  return (
    <div>
      <div className="border-b border-border bg-background px-6 lg:px-8 pt-6 pb-0">
        <div className="mb-4">
          <h1 className="text-2xl font-bold text-foreground">{title}</h1>
          {subtitle && <p className="mt-1 text-muted-foreground">{subtitle}</p>}
        </div>
        <div className="flex gap-1 overflow-x-auto -mb-px">
          {visibleTabs.map((tab) => (
            <NavLink
              key={tab.id}
              to={tab.to}
              className={({ isActive }) =>
                `px-4 py-2.5 text-sm font-medium border-b-2 whitespace-nowrap transition-colors ${
                  isActive
                    ? 'border-primary text-primary'
                    : 'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
                }`
              }
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      </div>
      <Outlet context={{ embedded: true }} />
    </div>
  )
}
